import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { MdDownloadForOffline } from "react-icons/md";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import profile from "../../assets/images/ProfileImage.jpg";
import MedicalService from "../../Services/MedicalService";
import { QRCodeCanvas } from "qrcode.react";
import { HSdecrypt } from "../../utils/encryptPassword";
import { convertUTCDate } from "../../utils/convertionFunc";
import dayjs from "dayjs";
import PatientService from "../../Services/PatientService";
import ChronicConditionService from "../../Services/ChronicConditionService";

function EmergencyCard(props) {
  const frontRef = useRef();
  const backRef = useRef();
  const [patientQrData, setPatientQrData] = useState();
  const [patDetails, setPatDetails] = useState(null);
  const [image, setImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [medications, setMedications] = useState([]);
  const [chronicConditions, setChronicConditions] = useState([]);
  const [patientAlleryData, setPatientAlleryData] = useState([]);

  useEffect(() => {
    PatientEmergencyData();
    patientMedication();
    getPatientDetails();
    PatientchronicConditions();
    PatientAllergies();
  }, [props]);

  const PatientAllergies = () => {
    let payload = {
      patientCode: props.selectedPatient,
      status: 1,
    };
    MedicalService.HSPatientAllergyList(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        const parsedAllergyData = JSON.parse(decryptedData);
        const filteredDrugAllergies = parsedAllergyData?.map((item) => ({
          drugAllergy: item["drugAllergy"],
        }));
        setPatientAlleryData(filteredDrugAllergies);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const PatientchronicConditions = () => {
    let payload = {
      patientId: props.selectedPatient,
    };
    ChronicConditionService.HSPatientchronicConditions(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setChronicConditions(JSON.parse(decryptedData));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getPatientDetails = async () => {
    const payload = {
      patientId: props?.selectedPatient,
    };

    try {
      const response = await PatientService.HSPatientData(payload);
      setPatDetails(response.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const patientMedication = () => {
    let payload = {
      patientCode: props.selectedPatient,
      status: 1,
    };
    MedicalService.HSPatientMedication(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setMedications(JSON.parse(decryptedData));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = frontRef.current;
    const backSide = backRef.current;

    if (!frontSide || !backSide) return;

    try {
      backSide.style.display = "none";

      const frontCanvas = await html2canvas(frontSide, {
        scale: 3,
        useCORS: true,
      });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";

      const backCanvas = await html2canvas(backSide, {
        scale: 3,
        useCORS: true,
      });
      const backImage = backCanvas.toDataURL("image/png");

      frontSide.style.display = "block";
      backSide.style.display = "none";

      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;

      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(
        backImage,
        "PNG",
        10,
        20 + frontHeight,
        imgWidth,
        backHeight
      );

      pdf.save("Emergency_MedicalCard.pdf");
    } finally {
      frontSide.style.display = "block";
      backSide.style.display = "block";
      backSide.style.transform = "rotateY(180deg)";
      backSide.style.backfaceVisibility = "hidden";
    }
  };

  const PatientEmergencyData = () => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      status: 1,
      patientId: patientDataV?.patientId,
    };
    MedicalService.PatientQrList(payload).then((result) => {
      if (result?.data[0]?.healthCardUrl) {
        let url =
          "https://doctor-dev.doxzon.com/emergencyqr/" +
          result?.data[0]?.healthCardUrl;
        setPatientQrData(url);
      }
    });
  };

  const generateQRCard = () => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      createdBy: patientDataV?.patientId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: patientDataV?.patientId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: patientDataV?.patientId,
      status: 1,
    };
    MedicalService.GenerateQr(payload).then((result) => {
      let url =
        "https://doctor-dev.doxzon.com/emergencyqr/" +
        result?.data?.healthCardUrl;
      PatientEmergencyData();
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };

  const handleCardClick = () => {
    setIsFlipped((prev) => !prev);
  };

  const calculateAge = (dob) => {
    const dobData = dob;
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };

  return (
    <>
      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">
            Emergency Medical Data
          </h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-60 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          <div className="p-3">
            <div className="flex gap-3">
              <div className="mt-2 w-[65%]">
                <div className="">
                  <div>
                    <h5 className="text-xs font-medium text-gray-500">
                      Name:{" "}
                      <span className="text-xs text-[#189FAA] font-bold">
                        {patDetails?.salutation +
                          " " +
                          patDetails?.firstName +
                          " " +
                          patDetails?.lastName}
                      </span>
                    </h5>
                    <h5 className="text-xs font-medium text-gray-500">
                      Age:{" "}
                      <span className="text-xs text-[#189FAA]font-bold">
                        {calculateAge(patDetails?.ageDob)}
                      </span>
                    </h5>
                    <h5 className="text-xs font-medium text-gray-500">
                      DOB:{" "}
                      <span className="text-xs text-[#189FAA]font-bold">
                        {patDetails?.dob}
                      </span>
                    </h5>
                    <h5 className="text-xs font-medium text-gray-500">
                      Address:{" "}
                      <span className="text-xs text-[#189FAA]font-bold">
                        {patDetails?.address1}
                      </span>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="w-[35%]">
                {patientQrData ? (
                  <>
                    <div className="w-full flex justify-end">
                      <button
                        className="border rounded-lg px-3 text-xs py-1 bg-[#189FAA] font-semibold text-white hover:bg-[#338f97]"
                        onClick={showModal}
                      >
                        View EMC
                      </button>
                    </div>
                    <div class="inline-block group mt-1 flex justify-end">
                      <QRCodeCanvas value={patientQrData} size={100} />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-full flex justify-end">
                      <button
                        className="border rounded-lg px-3 text-xs py-1 bg-[#189FAA] font-semibold text-white hover:bg-[#338f97]"
                        onClick={() => generateQRCard()}
                      >
                        Generate QR Code
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
            <hr />
            <div className="mt-2">
              <div className="flex gap-2">
                <p className="font-medium text-xs mt-1">Blood Group:</p>
                <p className="font-bold text-[#189FAA]">
                  {patDetails?.bloodGroup}
                </p>
              </div>
              <div
                className={`${
                  patientAlleryData.length === 1 ? "flex gap-2" : ""
                }`}
              >
                <p className="font-medium text-xs mt-1">Drug Allergy:</p>
                <div
                  className={`${
                    patientAlleryData.length === 1
                      ? ""
                      : "border grid grid-cols-2"
                  }`}
                >
                  {patientAlleryData?.map((item, idx) => (
                    <p key={idx} className="text-sm font-medium text-[#189FAA]">
                      {item.drugAllergy}
                    </p>
                  ))}
                </div>
              </div>
              <div
                className={`${
                  chronicConditions.length === 1 ? "flex gap-2" : ""
                }`}
              >
                <p className="font-medium text-xs mt-1">Chronic Conditions:</p>
                <div
                  className={`${
                    chronicConditions.length === 1
                      ? ""
                      : "border grid grid-cols-2"
                  }`}
                >
                  {chronicConditions?.map((item, idx) => (
                    <>
                      <div key={idx} className={``}>
                        <p className="text-sm font-medium text-[#189FAA]truncate">
                          {item.chronicDescription}
                        </p>
                      </div>
                    </>
                  ))}
                </div>
              </div>
              <div className="flex gap-2">
                <p className="font-medium text-xs mt-1">Insurance:</p>
                <p className="font-semibold text-[#189FAA]">
                  {patDetails?.insurance}
                </p>
              </div>
              <div className="">
                <p className="font-medium text-xs mt-1">Current Medications </p>
                <div className="overflow-x-auto scrollwidth">
                  <div className="grid grid-cols-1 gap-2">
                    {medications.map((pat, index) => (
                      <div
                        key={index}
                        className="bg-white p-2 rounded-lg shadow-md border border-gray-300"
                      >
                        <div>
                          <div className="flex justify-between">
                            <h3 className="text-sm font-bold text-[#189FAA]">
                              {pat.drugName}
                            </h3>
                            <p className="text-sm font-medium text-[#189FAA]">
                              {pat.dosage}
                            </p>
                            <p className="text-sm font-medium text-[#189FAA]">
                              {pat.dosageInstructions}
                            </p>
                          </div>
                          <div className="flex justify-between">
                            <div className="flex gap-2 items-center">
                              <h6 className="text-xs text-[#189FAA] font-medium">
                                On set Date:
                              </h6>
                              <h6 className="border rounded-md text-[10px] p-1">
                                {dayjs(pat.givenDate).format("YYYY-MM-DD")}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="w-full max-w-[370px] h-[300px] sm:h-[340px] md:h-[370px] md:m-5 border rounded-lg">
        <div className=" h-[13%] bg-secondaryColor flex items-center justify-center rounded p-2">
          <h1 className="font-bold text-normal text-white mt-3 text-center">
            Emergency Medical Data
          </h1>
        </div>
        <div className="h-[75%] overflow-y-auto scrollwidth bg-white border-t-2">
          <div className="p-3">
            <div className="flex gap-3">
              <div className="mt-2 w-[65%]">
                <div className="">
                  <div>
                    <h5 className="text-xs font-medium text-gray-500">
                      Name:{" "}
                      <span className="text-xs text-[#189FAA] font-bold">
                        {patDetails?.salutation +
                          " " +
                          patDetails?.firstName +
                          " " +
                          patDetails?.lastName}
                      </span>
                    </h5>
                    <h5 className="text-xs font-medium text-gray-500">
                      Age:{" "}
                      <span className="text-xs text-[#189FAA]font-bold">
                        {calculateAge(patDetails?.ageDob)}
                      </span>
                    </h5>
                    <h5 className="text-xs font-medium text-gray-500">
                      DOB:{" "}
                      <span className="text-xs text-[#189FAA]font-bold">
                        {patDetails?.dob}
                      </span>
                    </h5>
                    <h5 className="text-xs font-medium text-gray-500">
                      Address:{" "}
                      <span className="text-xs text-[#189FAA]font-bold">
                        {patDetails?.address1}
                      </span>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="w-[35%]">
                {patientQrData ? (
                  <>
                    <div className="w-full flex justify-end">
                      <button
                        className="border rounded-lg px-3 text-xs py-1 bg-[#189FAA] font-semibold text-white hover:bg-[#338f97]"
                        onClick={showModal}
                      >
                        View EMC
                      </button>
                    </div>
                    <div class="inline-block group mt-1 flex justify-end">
                      <QRCodeCanvas value={patientQrData} size={100} />
                     
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-full flex justify-end">
                      <button
                        className="border rounded-lg px-3 text-xs py-1 bg-[#189FAA] font-semibold text-white hover:bg-[#338f97]"
                        onClick={() => generateQRCard()}
                      >
                        Generate QR Code
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
            <hr />
            <div className="mt-2">
              <div className="flex gap-2">
                <p className="font-medium text-xs mt-1">Blood Group:</p>
                <p className="font-bold text-[#189FAA]">
                  {patDetails?.bloodGroup}
                </p>
              </div>
              <div
                className={`${
                  patientAlleryData.length === 1 ? "flex gap-2" : ""
                }`}
              >
                <p className="font-medium text-xs mt-1">Drug Allergy:</p>
                <div
                  className={`${
                    patientAlleryData.length === 1
                      ? ""
                      : "border grid grid-cols-2"
                  }`}
                >
                  {patientAlleryData?.map((item, idx) => (
                    <p key={idx} className="text-sm font-medium text-[#189FAA]">
                      {item.drugAllergy}
                    </p>
                  ))}
                </div>
              </div>
              <div
                className={`${
                  chronicConditions.length === 1 ? "flex gap-2" : ""
                }`}
              >
                <p className="font-medium text-xs mt-1">Chronic Conditions:</p>
                <div
                  className={`${
                    chronicConditions.length === 1
                      ? ""
                      : "border grid grid-cols-2"
                  }`}
                >
                  {chronicConditions?.map((item, idx) => (
                    <>
                      <div key={idx} className={``}>
                        <p className="text-sm font-medium text-[#189FAA]truncate">
                          {item.chronicDescription}
                        </p>
                      </div>
                    </>
                  ))}
                </div>
              </div>
              <div className="flex gap-2">
                <p className="font-medium text-xs mt-1">Insurance:</p>
                <p className="font-semibold text-[#189FAA]">
                  {patDetails?.insurance}
                </p>
              </div>
              <div className="">
                <p className="font-medium text-xs mt-1">Current Medications </p>
                <div className="overflow-x-auto scrollwidth">
                  <div className="grid grid-cols-1 gap-2">
                    {medications.map((pat, index) => (
                      <div
                        key={index}
                        className="bg-white p-2 rounded-lg shadow-md border border-gray-300"
                      >
                        <div>
                          <div className="flex justify-between">
                            <h3 className="text-sm font-bold text-[#189FAA]">
                              {pat.drugName}
                            </h3>
                            <p className="text-sm font-medium text-[#189FAA]">
                              {pat.dosage}
                            </p>
                            <p className="text-sm font-medium text-[#189FAA]">
                              {pat.dosageInstructions}
                            </p>
                          </div>
                          <div className="flex justify-between">
                            <div className="flex gap-2 items-center">
                              <h6 className="text-xs text-[#189FAA] font-medium">
                                On set Date:
                              </h6>
                              <h6 className="border rounded-md text-[10px] p-1">
                                {dayjs(pat.givenDate).format("YYYY-MM-DD")}
                              </h6>
                            </div>

                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="border-gray-300" />
        </div>
        <div className="footer h-[44px] bg-secondaryColor rounded"></div>
      </div> */}
      <Modal
        title={
          <div className="flex justify-end space-x-4">
            <MdDownloadForOffline
              className="text-[#189FAA] cursor-pointer font-bold w-6 h-6"
              onClick={handleDownload}
            />
            <CloseOutlined
              className="text-white cursor-pointer"
              onClick={handleCancel}
            />
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={500}
        footer={
          <div>
            {/* <div className="flex justify-end space-x-4 mt-6">
            <button className="px-4 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300" onClick={handleDownload}>
              Download
            </button>
          </div> */}
          </div>
        }
      >
        <div
          className="relative w-full h-[250px] perspective cursor-pointer"
          onClick={handleCardClick}
        >
          <div
            className={`relative w-full h-full transform-style-preserve-3d transition-transform duration-700 ${
              isFlipped ? "rotate-y-180" : ""
            }`}
          >
            <div
              className="absolute w-full backface-hidden border-2 border-slate-200 rounded-lg bg-white"
              ref={frontRef}
            >
              <div className="h-10 bg-[#189FAA] rounded-md flex justify-center items-center">
                <p className=" font-semibold text-center text-base text-white">
                  Emergency Medical Card
                </p>
              </div>
              <div className="w-full p-2 flex justify-evenly">
                <div className="flex gap-5 w-[75%]">
                  <div className="w-24 h-25 bg-white border rounded-xl flex items-center justify-center overflow-hidden">
                    {patDetails?.photoNameBase64 ? (
                      <img
                        src={
                          "data:image/jpeg;base64," +
                          patDetails?.photoNameBase64
                        }
                        alt=""
                        className="w-full h-full object-cover rounded-xl"
                      />
                    ) : (
                      <img
                        src={profile}
                        alt=""
                        className="w-full h-full object-cover "
                      />
                    )}
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Name:{" "}
                      <span className="font-bold text-[#189FAA]">
                        {" "}
                        {patDetails?.salutation +
                          " " +
                          patDetails?.firstName +
                          " " +
                          patDetails?.lastName}
                      </span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Age:{" "}
                      <span className="font-bold text-[#189FAA]">
                        {calculateAge(patDetails?.ageDob)}
                      </span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      BloodGroup:{" "}
                      <span className="font-bold text-[#189FAA]">
                        {patDetails?.bloodGroup}
                      </span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Mobile No:{" "}
                      <span className="font-bold text-[#189FAA]">
                        {patDetails?.mobile}
                      </span>
                    </h4>
                  </div>
                </div>
                <div className="w-[25%]">
                  <div className="w-24 h-24 rounded-lg flex items-center justify-center mt-3 bg-white border">
                    {patientQrData && (
                      <QRCodeCanvas
                        value={patientQrData}
                        size={100}
                        className="mt-2"
                      />
                    )}{" "}
                  </div>
                </div>
              </div>
              <div className="h-7 bg-red-600 flex items-center justify-center">
                <p className="text-sm font-semibold text-white">
                  Emergency Contact
                </p>
              </div>
              <div className="flex justify-evenly items-center my-2">
                {/* <h6 className="text-xs font-medium">
                  Name:{" "}
                  <span className="text-sm font-semibold">
                    {" "}
                    {patDetails?.salutation +
                      " " +
                      patDetails?.firstName +
                      " " +
                      patDetails?.lastName}
                  </span>
                </h6> */}
                <h6 className="text-xs font-medium">
                  Mobile Number:{" "}
                  <span className="text-sm font-semibold">
                    {patDetails?.emergencyContact}
                  </span>
                </h6>
              </div>
            </div>
            <div
              className="absolute w-full h-60 backface-hidden rotate-y-180 border-2 border-slate-200 rounded-md"
              ref={backRef}
            >
              <div className="h-10 bg-white-800 rounded-md flex justify-center items-center">
                <p className="font-semibold text-center text-base text-white">
                  {/* Emergency Medical Card */}
                </p>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-center text-center mt-5">
                  <p className="text-sm font-semibold">
                    Access my personal Health Records At:
                    <br />
                    <a
                      href={`${process.env.REACT_APP_FRONTEND_URL?.replace(
                        /\/$/,
                        ""
                      )}/PHR-ACCESS/${patDetails?.patientId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#189FAA]"
                    >
                      {`${process.env.REACT_APP_FRONTEND_URL?.replace(
                        /^https?:\/\//,
                        ""
                      )}PHR-ACCESS`}
                    </a>
                  </p>
                </div>
                <div className="flex justify-center items-center gap-10">
                  <div>
                    <p className="text-sm font-semibold">
                      MEMBER ID:{" "}
                      <span className="text-sm font-bold text-[#189FAA]">
                        {patDetails?.patientId}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default EmergencyCard;
